module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/4-390fdd411cd607f790876544a0536519.jpg";